<template>
    <v-card class="card-container visitor-attendance">
        <div class="card-header">
            <div class="content-header">{{ $vuetify.lang.t('$vuetify.visitorAttendance.history') }}</div>
        </div>
        <div class="content-container visitor-table">
            <v-data-table
                fixed-header
                hide-default-footer
                :headers="headers"
                :items="attendanceData"
                disable-pagination>
            </v-data-table>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'VisitorAttendance',

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.visitorAttendance.date'), value: 'date' },
                { text: this.$vuetify.lang.t('$vuetify.visitorAttendance.checkIn'), value: 'checkIn', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.visitorAttendance.checkOut'), value: 'checkOut', sortable: false }
            ]
        }
    },
    data () {
        return {
            attendanceData: []
        }
    },

    methods: {
        async getVisitorAttendance (id) {
            const res = await this.axios.get(`visitor/history/${id}`)
            if (res && res.data && res.data.status === 'ok') {
                this.attendanceData = res.data.data
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.visitor-attendance {
    width: 100%;

    .card-header {
        padding: 2rem;
    }
}
.card-container {
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05)!important;
    border-radius: 15px !important;
}

::v-deep .content-container {
    .v-data-table__wrapper {
        height: calc(81vh - 120px) !important;
    }

    .v-data-table__wrapper {
        thead.v-data-table-header {

            th {
                height: 46px;
                max-width: 1px;
                color: #ffffff;
                white-space: nowrap;
                background-color: #6c6c6c;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            span, i {
                font-weight: normal;
                font-size: 15px !important;
                color: white !important;
            }

            i {
                padding: 5px;
            }
        }

        tbody td {
            height: 55px;
            font-size: 16px;
        }
    }

    // scroll bar for fixed header
    .v-data-table--fixed-header .v-data-table__wrapper {
        overflow-y: scroll;
    }

    .v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar {
        width: 6px;
        background-color: #FFFFFF;
    }

    .v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #e5e5e5;
    }

    .v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #FFFFFF;
    }
}
</style>
